import { render, staticRenderFns } from "./ArticleFilter.vue?vue&type=template&id=c6a99b52&scoped=true&"
import script from "./ArticleFilter.vue?vue&type=script&lang=js&"
export * from "./ArticleFilter.vue?vue&type=script&lang=js&"
import style0 from "./ArticleFilter.vue?vue&type=style&index=0&id=c6a99b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a99b52",
  null
  
)

export default component.exports